import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { conditional } from 'utils/shapes';

import './BikeCardInfo.css';

const BikeLocationLink = translate(['translation'])(
  ({ t, showBikeLocation }) => (
    <p>
      <span
        className="bike-card-show-on-map"
        onClick={showBikeLocation}
      >
        {t('Show on the map')}
      </span>
    </p>
  )
);

class BikeCardInfo extends PureComponent {
  showBikeLocation = event => {
    event.preventDefault();

    const {
      showBikeLocation,
      bike
    } = this.props;

    showBikeLocation(bike);
  };

  render() {
    const {
      t,
      bike,
      bikeTypes,
      showBikeLocationLink
    } = this.props;

    const bikeType = bikeTypes.find(bt => bt.id === bike.bikeType);
    const bikeTypeName = bikeType ? t(bikeType.name, { ns: 'bikeTypes' }) : '';

    return (
      <div className="bike-card-info">
        <h3>{bikeTypeName} {bike.name}</h3>

        {showBikeLocationLink && (
          <BikeLocationLink showBikeLocation={this.showBikeLocation} />
        )}

        <p>
          <b>{t('Description')}:</b>
          {bike.description.split('\n').map((item, key) =>
            <span key={key}>{item}<br/></span>
          )}
        </p>

        {!!bike.drivingLicense && (
          <p>
            <b>{t('Driver\'s license')}:</b>
            <b>«{t(bike.drivingLicense)}»</b>
          </p>
        )}

        <p>
          <b>{t('Minimum age')}:</b>
          {bike.minAge}
        </p>
      </div>
    );
  }
}

BikeCardInfo.propTypes = {
  bike: PropTypes.object.isRequired,
  bikeTypes: PropTypes.array,
  t: PropTypes.func.isRequired,
  showBikeLocationLink: PropTypes.bool.isRequired,
  showBikeLocation: conditional('showBikeLocationLink', PropTypes.func.isRequired)
};

export default translate(['translation', 'bikeTypes'])(BikeCardInfo);



// WEBPACK FOOTER //
// ./src/widgets/BikeCard/BikeCardInfo.js